import axios from 'axios';
import qs from 'qs';
import { jwtDecode } from 'jwt-decode';

export const isTokenValid = (token: string): boolean => {
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    return (
      decodedToken &&
      typeof decodedToken.exp === 'number' &&
      decodedToken.exp > currentTime
    );
  } catch (e) {
    console.error('Invalid token:', e);
    return false;
  }
};

export const login = async (username: string, password: string) => {
  
  const apiUrl = `${process.env.REACT_APP_API_URL}/v1/systemUsersAuth/login`;


  if (!apiUrl) {
    throw new Error('API URL is not defined');
  }

  try {
    const data = qs.stringify({ username, password });

    const response = await axios.post(apiUrl, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-business': 'GASCO',
        'x-commerce': 'GASCO',
        'x-country': 'CL',
        'x-system': 'fe-identity-validation',
        'x-user': 'IdentityValidation',
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error(
        'Login error:',
        error.response ? error.response.data : error.message
      );
    } else {
      console.error('Unexpected error:', error);
    }
    throw error;
  }
};
